import { createFileRoute } from '@tanstack/react-router';

import { SessionRolloverPage } from '~pages/sessions';

export const Route = createFileRoute(
  '/_auth/_layout/sessions/$sessionId/rollover',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { sessionId } = Route.useParams();
  return <SessionRolloverPage initialSourceSessionId={sessionId} />;
}
